import { normalizeSearchText, normalizeSearchTextWithMap } from "./search_text.js"

export function searchHighlightSegments(text, query) {
  const source = String(text || "")
  const normalized = normalizeSearchTextWithMap(source)
  const normalizedQuery = normalizeSearchText(query)
  if (!normalizedQuery) return [{ text: source, highlighted: false }]

  const ranges = []
  let searchOffset = 0
  while ((searchOffset = normalized.text.indexOf(normalizedQuery, searchOffset)) !== -1) {
    const firstCharacter = normalized.map[searchOffset]
    const lastCharacter = normalized.map[searchOffset + normalizedQuery.length - 1]
    ranges.push({ start: firstCharacter.startOffset, end: lastCharacter.endOffset })
    searchOffset += normalizedQuery.length
  }
  if (ranges.length === 0) return [{ text: source, highlighted: false }]

  const segments = []
  let sourceOffset = 0
  ranges.forEach((range) => {
    if (range.start > sourceOffset) segments.push({ text: source.slice(sourceOffset, range.start), highlighted: false })
    segments.push({ text: source.slice(range.start, range.end), highlighted: true })
    sourceOffset = range.end
  })
  if (sourceOffset < source.length) segments.push({ text: source.slice(sourceOffset), highlighted: false })
  return segments
}

export function renderSearchHighlight(element, text, query) {
  const document = element.ownerDocument
  const nodes = searchHighlightSegments(text, query).map((segment) => {
    if (!segment.highlighted) return document.createTextNode(segment.text)

    const mark = document.createElement("mark")
    mark.className = "reader-search-highlight"
    mark.textContent = segment.text
    return mark
  })

  element.replaceChildren(...nodes)
}
